import type { TurnOffCompanyDomainSuggestionsData } from 'api/dist/routes/organization/[organization_id]/company-domain/[domain_id]/index.js'
import type { IApi } from '@/setup/api-client'
import { useApiMutation } from '@/utils/api/api-mutation'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'
import { GetCompanyDomainQuery } from '@/api/organization/company-domain/get-company-domain-query'

export interface ITurnOffCompanyDomainSuggestionsParams {
    organizationId: string
    domainId: string
}

export type ITurnOffCompanyDomainSuggestionsResult = TurnOffCompanyDomainSuggestionsData

/** Turns off automatic enrollment for one exact Clerk domain. */
export class TurnOffCompanyDomainSuggestionsMutation {
    static call(api: IApi, params: ITurnOffCompanyDomainSuggestionsParams) {
        return api
            .patch<
                TurnOffCompanyDomainSuggestionsData,
                Record<string, never>
            >(`/organization/${params.organizationId}/company-domain/${encodeURIComponent(params.domainId)}`, {})
            .then((response) => response.data)
    }
}

/** Keeps status invalidation pinned to the workspace used for this mutation. */
export function getTurnOffCompanyDomainSuggestionsInvalidation(params: ITurnOffCompanyDomainSuggestionsParams) {
    return {
        queryKey: GetCompanyDomainQuery.getKey({ organizationId: params.organizationId }),
        refetchType: 'none' as const,
    }
}

/** Mutates an explicitly prepared workspace-domain pair and marks its live Clerk status stale. */
export function useTurnOffCompanyDomainSuggestionsMutation() {
    const { api, qc } = useApiToolbox()

    return useApiMutation<ITurnOffCompanyDomainSuggestionsResult, ITurnOffCompanyDomainSuggestionsParams>({
        mutationFn: (params) => TurnOffCompanyDomainSuggestionsMutation.call(api, params),
        onSuccess: (_result, params) => qc.invalidateQueries(getTurnOffCompanyDomainSuggestionsInvalidation(params)),
    })
}
